<template>
  <div class="_display:flex _flex-direction:column" am-modal-array-input>
    <div
      v-for="(value, index) in data.data"
      :key="index"
      class="_display:inline-flex _align-items:center _width:100% _margin-bottom:1/4"
    >
      <i-input
        v-model="val[index]"
        @change="setChangedParts(index)"
      />
      <div class="_margin-left:1/4">
        <svg viewBox="0 0 24 24" am-icon="color" @click="delArray(index)">
          <use xlink:href="@/assets/icons.svg#minus"  x="0" y="0" width="24" height="24"></use>
        </svg>
      </div>
    </div>
    <svg viewBox="0 0 24 24" am-icon class="_margin-top:1/2" @click="addArray()">
      <use xlink:href="@/assets/icons.svg#plus" x="0" y="0" width="24" height="24"></use>
    </svg>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'FieldsArrayItem',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    isActive: false
  }),
  computed: {
    val () {
      return this.$store.state.parts.data[this.$route.params.subtable].parts[this.data.index].data
    }
  },
  methods: {
    ...mapMutations('parts', ['SET_CHANGED_PARTS']),
    setChangedParts (index) {
      if (this.val[index]) this.val[index] = this.val[index].toUpperCase()
      this.SET_CHANGED_PARTS({ subtable: this.$route.params.subtable, data: this.data })
    },
    delArray (index) {
      this.val.splice(index, 1)
      this.setChangedParts()
    },
    addArray () {
      this.val.push('')
      this.setChangedParts()
    }
  }
}
</script>

<style lang="scss">
  [am-modal-array-input] {
    input {
      text-transform: uppercase;
    }
  }
</style>
